import type { SVGProps } from 'react';

const SvgLineTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height={17}
    viewBox='0 0 16 17'
    width={16}
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.723 2.003a.5.5 0 0 1 .441.553l-1.333 12a.5.5 0 0 1-.994-.112l1.333-12a.5.5 0 0 1 .553-.441M10.723 2.003a.5.5 0 0 1 .441.553l-1.333 12a.5.5 0 0 1-.994-.112l1.333-12a.5.5 0 0 1 .553-.441'
      fill='#3889FF'
    />
    <path
      d='m14.334 6 .1.01a.5.5 0 0 1 0 .98l-.1.01h-12a.5.5 0 0 1 0-1zM13.666 10l.1.01a.5.5 0 0 1 0 .98l-.1.01h-12a.5.5 0 0 1 0-1z'
      fill='#3889FF'
    />
  </svg>
);
export default SvgLineTag;
